import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalService, BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { FormsModule } from '@angular/forms';

import { SharedNotesRoutingModule } from './shared-notes-routing.module';
import { SharedAddNotesComponent } from './shared-add-notes/shared-add-notes.component';

@NgModule({
    declarations: [SharedAddNotesComponent],
    imports: [
        CommonModule,
        SharedNotesRoutingModule,
        FormsModule
    ],
    providers: [BsModalService],
    exports: [SharedAddNotesComponent]
})
export class SharedNotesModule { }
